import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
} from "../shared";

@Injectable({ providedIn: "root" })
export class InnovatifUserVerificationService extends BaseApiTemplateService<any> {
  static readonly INNOVATIF_USER_VERIFY_SUBPATH = "okay-face-verify/";

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.TPY_PREFIX +
      Core2Config.INNOVATIF_EKYC_PREFIX +
      InnovatifUserVerificationService.INNOVATIF_USER_VERIFY_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.TPY_PREFIX +
      Core2Config.INNOVATIF_EKYC_PREFIX +
      InnovatifUserVerificationService.INNOVATIF_USER_VERIFY_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
  }

  public verifyUser(
    dtoObject: FormData,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public reinitiateVerification(
    guid:string, 
    dtoObject: FormData,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/" + guid;
    }
    return this.httpClient.put<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
